<template>
  <div class="positionItem" @click="goDetail(row.id)">
    <h3>
      <label>{{ row.name }}</label>
      <span>New</span>
    </h3>
    <div class="info">
      <span>{{ row.city }}</span>
      <span>|</span>
      <span>{{ row.category }}</span>
      <span>|</span>
      <span>{{ enumType[row.positionType] }}</span>
    </div>
  </div>
</template>
<script>
import positionType from "@/enum/positionType"
export default {
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      enumType: positionType
    };
  },
  methods: {
    goDetail(id) {
      if (id) {
        this.$router.push({
          path: `/join/detail/${id}`,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.positionItem {
  padding: 20px 22px;
  background: #ffffff;
  box-sizing: border-box;
  border-bottom: 1px solid #d8dcdf;
  * {
    margin: 0;
  }
  h3 {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
    label {
      font-weight: normal;
      font-size: 18px;
      color: #242a32;
      margin-right: 8px;
    }
    span {
      color: #ff4d00;
      font-size: 12px;
    }
  }

  .info {
    span {
      margin-right: 10px;
      font-size: 12px;
      color: #5e656c;
    }
  }
}
</style>